import { useTranslation } from 'react-i18next';

import {
  CampaignWrapper,
  ImageWrapper,
  TileImage,
  CampaignLabel,
  CampaignText,
} from './StyledComponents';

export const CampaignIcon = ({
  name,
  tileImage,
  isActive,
  isSelected,
  onClick,
}) => {
  const { t } = useTranslation('activityBoard');

  return (
    <CampaignWrapper onClick={onClick} data-testid="campaign-wrapper">
      <ImageWrapper>
        <TileImage
          alt=""
          height="58px"
          width="58px"
          isSelected={isSelected}
          src={tileImage}
          data-testid="tile-image"
        />
        {isActive && (
          <CampaignLabel
            isSelected={isSelected}
            fontSize="12px"
            fontWeight="600"
          >
            {t('campaignIcon.live')}
          </CampaignLabel>
        )}
      </ImageWrapper>
      <CampaignText isSelected={isSelected} variant="subtitle2">
        {name}
      </CampaignText>
    </CampaignWrapper>
  );
};
